function isValidIdentifier(str: string): boolean {
    if (!str)
        return false;

    return /^[a-zA-Z_$][a-zA-Z0-9_$]*$/.test(str);
}

function snake2camel(name: string): string {
    // function taken from Angular source code (MIT License)
    const mozHackRegexp = /^moz([A-Z])/;
    const specialCharsRegexp = /([:\-_]+(.))/g;
    return name.replace(specialCharsRegexp, (_: string, separator: string, letter: string, offset: number) =>
        (offset ? letter.toUpperCase() : letter)).replace(mozHackRegexp, "Moz$1");
}

function cleanVariableName(name: string): string | null {

    name = name.trim().toLowerCase();

    name = name.replace(/^['"]/, "");
    name = name.replace(/['"]$/, "");
    name = name.replace(/\W/g, "_");
    name = name.replace(/[^a-zA-Z0-9_]/g, "");

    // if string ends with an underscore, remove it
    if (name.endsWith("_"))
        name = name.substr(0, name.length - 1);

    name = name.replace(/_{2,}/g, "_");
    name = snake2camel(name);

    if (isValidIdentifier(name))
        return name;
    else
        return null;
}

export function clearVariableNames(names: string[]): string[] {
    return names.map(cleanVariableName).filter((it): it is string => it !== null);
}
